/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import CircularProgress from '../../atoms/CircularProgress';

const LoadingArea: React.FC<any> = () => {
  return (
    <div className='u-flex u-h-viewport u-items-center u-justify-center' data-testid='loading-area'>
      <div className='u-text-center'>
        <CircularProgress isIndeterminate hasBackground={false} />
        <p>ページを読み込んでいます...</p>
      </div>
    </div>
  );
};
export default LoadingArea;
